import store from 'dashboard/store';

import app from "../../../../../app";

import DSS from 'dashboard/templates/views/DSS/DSS';

import cardioMedication from './cardio-medication';
import otherMedication from './other-medication';
import sideEffects from './side-effects';
import titrationSchemes from './titration-schemes';
import medicationPrescription from './medication-prescription';
import algorithmInputs from './algorithm-inputs';

import {ROLE_DSS} from 'dashboard/store/user/role-tree';
import {resetStore} from "../../../../hooks/patient-id-guard";
import {redirectIfBehaviourModulesAreNotEnabled} from "../../../../hooks/enabled-module-guard";

/**
 * DSS routes
 * @name router.DSS
 */

export default {
    path: 'dss',
    component: DSS,
    meta: {
        title: t => `${t('people.patient')} - DSS`,
        loggedInOnly: true,
        inSDMSessionOnly: true
    },
    children: [
        cardioMedication,
        otherMedication,
        sideEffects,
        titrationSchemes,
        medicationPrescription,
        algorithmInputs,
    ],
    async beforeEnter(to, from, next) {
        const currentPatientId = from.params?.patientId;
        const newPatientId = to.params?.patientId;

        // If user was redirected from page because medication adherence is not enabled, don't do anything.
        if (await redirectIfBehaviourModulesAreNotEnabled(["MEDICATIONS"], to, next, newPatientId)){
            return
        }

        // Update user if back is used as everything stays cached in computed
        if ((currentPatientId === undefined && newPatientId) ||
            currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
        ) {
            await Promise.all([
                store.dispatch('patientSummary/get', newPatientId, {root: true}),
            ]);
        }

        await Promise.all([
            store.dispatch('dss/getDSSMedicationSchedules'),
            store.dispatch('dss/getMedicationClasses'),
            store.dispatch('dss/getPatientQuestionnaires'),
            store.dispatch('dss/getDSSMedicationScheduleAuditTrails'),
            // TODO: add something for algorithm
        ]);

        // Get last audit trails from local storage in case of refresh
        if (localStorage.getItem('DSSLastAuditTrails')) {
            const DSSFirstLoad = JSON.parse(localStorage.getItem('DSSFirstLoad'));
            const DSSLastAuditTrails = JSON.parse(localStorage.getItem('DSSLastAuditTrails'));
            // only if patient id has not changed
            if (parseInt(DSSFirstLoad.patientId) === parseInt(newPatientId)) {
                store.dispatch('dss/setDSSLastAuditTrails', DSSLastAuditTrails)
                store.dispatch('dss/setDSSFirstLoad', DSSFirstLoad)
            }
            localStorage.removeItem('DSSLastAuditTrails');
            localStorage.removeItem('DSSFirstLoad');
        }

        if (store.getters['user/hasDSSAccess']) {
            next();
        } else {
            store.dispatch("error/submit", new Error(app.translationManager.translate("system.noAccessPage", {catalog : "app_dashboard"})))
            next(from.path);
        }
    },
};
